import shouldBeSelected from '../helpers/shouldBeSelected';
import useDevTools from '../hooks/useDevTools';
import styles from './Properties.module.scss';
import cn from 'classnames';
import dotProp from 'dot-prop-immutable';
import { useSelector } from 'react-redux';

const isDifferent = (currentValue, defaultValue) => {
  if (Array.isArray(currentValue)) {
    const la = currentValue.length;
    const lb = defaultValue.length;

    if (la !== lb) {
      return true;
    }

    for (let i = 0; i < la; i++) {
      if (currentValue[i] !== defaultValue[i]) {
        return true;
      }
    }
  } else {
    return currentValue !== defaultValue;
  }

  return false;
};

const formatValue = (item) => {
  if (item.type === 'boolean') {
    return item.value ? 'true' : 'false';
  }

  if (item.value === undefined) {
    return item.undefinedText || 'undefined';
  }

  if (Array.isArray(item.value)) {
    const mapped = item.value.map((a) => (typeof a === 'number' ? a.toFixed(5) : a)).join(', ');

    return `[${mapped}]`;
  }

  return item.value.toString();
};

const Properties = ({ data, title, regularChange, extraChange, index, showDiff = true, importantNote }) => {
  const state = useSelector((s) => s.default);
  const { menu } = useDevTools();

  return (
    <div className={cn(styles.container, importantNote && styles.important)}>
      {importantNote && <div className={styles.importantNote}>{importantNote}</div>}
      <div className={styles.header}>{title}</div>
      <ul>
        {data.map((item) => {
          return (
            <li
              key={item.id}
              onClick={() => {
                if (!item.readonly) {
                  if (item.regular) {
                    regularChange(item);
                  } else {
                    extraChange(item);
                  }
                }
              }}
              className={cn(!item.readonly && styles.showPointer, shouldBeSelected(item.name, menu, index) && styles.selected)}
            >
              <div className={styles.left}>
                {showDiff && isDifferent(dotProp.get(state, item.id), item.value) && <div className={styles.changed} />}
                <div className={styles.name}>{item.name}</div>
              </div>
              <div className={styles.right}>
                {item.readonly && <span className={styles.readonly}>readonly</span>}

                <div className={cn(styles.value, styles[item.type || 'any'])}>{formatValue(item)}</div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Properties;
